'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_UnauthenticatedAppUpdate$$anon$16() {
}
export { $c_Lapp_api_UnauthenticatedAppUpdate$$anon$16 as $c_Lapp_api_UnauthenticatedAppUpdate$$anon$16 };
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$16.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$16.prototype.constructor = $c_Lapp_api_UnauthenticatedAppUpdate$$anon$16;
/** @constructor */
function $h_Lapp_api_UnauthenticatedAppUpdate$$anon$16() {
}
export { $h_Lapp_api_UnauthenticatedAppUpdate$$anon$16 as $h_Lapp_api_UnauthenticatedAppUpdate$$anon$16 };
$h_Lapp_api_UnauthenticatedAppUpdate$$anon$16.prototype = $c_Lapp_api_UnauthenticatedAppUpdate$$anon$16.prototype;
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$16.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$16.prototype.apply__Lsttp_tapir_Schema = (function() {
  var $x_1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lframework_prelude_newtype\uff3ftapir$package$();
  var \u03b4proxy7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_IsProductionMode$package$IsProductionMode$();
  return $x_1.newTypeSchema__Lyantl_INewtype__Lsttp_tapir_Schema__Lsttp_tapir_Schema(\u03b4proxy7, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lsttp_tapir_Schema$().Lsttp_tapir_Schema$__f_schemaForBoolean);
});
$c_Lapp_api_UnauthenticatedAppUpdate$$anon$16.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_api_UnauthenticatedAppUpdate$$anon$16 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_UnauthenticatedAppUpdate$$anon$16, "app.api.UnauthenticatedAppUpdate$$anon$16", ({
  Lapp_api_UnauthenticatedAppUpdate$$anon$16: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_UnauthenticatedAppUpdate$$anon$16 as $d_Lapp_api_UnauthenticatedAppUpdate$$anon$16 };
//# sourceMappingURL=app.api.-Unauthenticated-App-Update$$anon$16.js.map
